import Search from "../../assets/search.svg";
import { InputSearchContainer } from "./style";

export function InputSearch() {
  return (
    <InputSearchContainer>
      <form>
        <input type="text" placeholder="Buscar produtos" />
        <button type="button">
          |<img src={Search} alt="search" />
        </button>
      </form>
    </InputSearchContainer>
  );
}
